const ArrowRightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="st0" width="22" viewBox="0 0 22 22.001" style={{marginTop:3}}>
            <g className="st1">
                <path className="st2" d="M9.2,3l4.9,4.9c0.1,0.1,0.1,0.3,0,0.4l-4.9,4.9c-0.1,0.1-0.3,0.1-0.4,0l-0.2-0.2c-0.1-0.1-0.1-0.3,0-0.4
		l4.6-4.6L8.6,3.5c-0.1-0.1-0.1-0.3,0-0.4L8.8,3C8.9,2.9,9.1,2.9,9.2,3z"/>
            </g>
        </svg>
    );
}

export default ArrowRightIcon;
